import { DepthKeys } from '@/hooks'
import { INavItem } from '@/types'
import {
  carHirePath,
  generatePath,
  vehiclesPath,
  oneWayRentalsPath,
  viewModifyCancelPath,
  carRentalLocationsPath,
  yerevanSlug,
  yerevanAirportSlug,
  internationalLocationsPath,
  contactUsPath,
  aboutUsPath,
} from '@/utils'

export const menuPaths: INavItem<DepthKeys>[] = [
  {
    title: 'reservations',
    subPaths: [
      {
        path: carHirePath,
        title: 'startAReservation',
      },
      {
        path: viewModifyCancelPath,
        title: 'viewModifyCancel',
      },
      {
        path: oneWayRentalsPath,
        title: 'oneWayRentals',
      },
    ],
  },
  {
    path: vehiclesPath,
    title: 'vehicles',
  },
  {
    title: 'locations',
    subPaths: [
      {
        path: generatePath(carRentalLocationsPath, {}, [
          { location: yerevanAirportSlug },
        ]),
        title: 'zvartnotsAirport',
      },
      {
        path: generatePath(carRentalLocationsPath, {}, [
          { location: yerevanSlug },
        ]),
        title: 'yerevanDowntown',
      },
      {
        isExternal: true,
        path: internationalLocationsPath,
        title: 'allInternationalLocations',
      },
    ],
  },
  {
    path: contactUsPath,
    title: 'customerSupport',
  },
  {
    path: aboutUsPath,
    title: 'aboutUs',
  },
]
